import { getDefaultAnchorMailboxCookie } from 'owa-ows-gateway/lib/anchormailbox';
import buildQueryParams from 'owa-search-service/lib/helpers/buildQueryParams';
import { getAccessTokenforResourceAsLazy } from 'owa-tokenprovider';
import { getUrlWithAddedQueryParameters } from 'owa-url';
import { isFeatureEnabled } from 'owa-feature-flags';

const CONTENT_TYPE = 'application/json;charset=utf-8';
const MRU_ENDPOINT = '/search/api/v1/recommendations';

export default async function fetchMeetingInsightsService(
    itemId: string,
    clientRequestId: string,
    scenarioEndPoint: string
): Promise<Response> {
    const token: string = await getTokenForMRUService();
    const requestInit: RequestInit = createRequestInit(
        itemId,
        scenarioEndPoint,
        clientRequestId,
        token
    );

    const response: Response = await fetch(
        getUrlWithAddedQueryParameters(MRU_ENDPOINT, buildQueryParams()),
        requestInit
    );
    return response;
}

async function getTokenForMRUService(): Promise<string> {
    let [token, tokenPromise] = getAccessTokenforResourceAsLazy(window.location.origin);
    // If token is not returned synchronously, we need to await on the tokenPromise
    if (!token) {
        token = (await tokenPromise) as string;
    }
    return token as string;
}

function createRequestInit(
    itemId: string,
    scenarioEndPoint: string,
    clientRequestId: string,
    token: string
): RequestInit {
    const requestInit: RequestInit = {};
    requestInit.headers = new Headers();
    // Authorization
    (<Headers>requestInit.headers).set('Authorization', `Bearer ${token}`);
    // Content-Type
    (<Headers>requestInit.headers).set('Content-Type', CONTENT_TYPE);
    // Method
    requestInit.method = 'POST';
    // X-AnchorMailbox
    const defaultAnchorMailbox = getDefaultAnchorMailboxCookie();
    if (defaultAnchorMailbox) {
        (<Headers>requestInit.headers).append('X-AnchorMailbox', defaultAnchorMailbox);
    }
    // X-Client-LocalTime
    (<Headers>requestInit.headers).set('X-Client-LocalTime', new Date().toISOString());

    // X-Client-Id
    (<Headers>requestInit.headers).set('client-request-id', clientRequestId);

    // X-Client-Flights
    if (isFeatureEnabled('cal-meeting-insights-reasonMarkers')) {
        (<Headers>requestInit.headers).set(
            'X-Client-Flights',
            'recV0Hack,recEnableMeetingAttachments,ReasonMarkers '
        );
    } else {
        (<Headers>requestInit.headers).set(
            'X-Client-Flights',
            'recV0Hack,recEnableMeetingAttachments'
        );
    }

    const data = {
        EntityRequests: [
            {
                Context: {
                    EntityId: itemId,
                },
            },
        ],
        Scenario: {
            Name: scenarioEndPoint,
        },
    };

    requestInit.body = JSON.stringify(data);
    return requestInit;
}
